import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var DeadlinesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DeadlinesService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getSubscriptionsList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        // Force V2: the subscription deadlines list is V2-shaped (consumes data.items)
        // and the search[forfait] filter is only honored by the V2 endpoint
        // (V1 uses forfait solely for sorting).
        return this.apiService.apiCall('GET', 'deadlines/subscriptions', params, undefined, undefined, undefined, 'v2');
    };
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getDocumentsList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'deadlines/documents', params);
    };
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getSubscriptionsSuppliersList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'deadlines/subscriptions-suppliers', params);
    };
    /**
       * Get deadlines list for given query params
       *
       * @since 1.0.0
       *
       * @param [propertyId] Query left offset
       * @param [start] Query left offset
       * @param [limit] Results number
       * @param [sort] Sorting field name
       * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
       * @param [search] Filtering object with fildering data string
       */
    DeadlinesService.prototype.getDocumentsPopertyList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "deadlines/property/" + propertyId + "/documents", params);
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-subscriptions', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsSuppliersExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-subscriptions-suppliers', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsNfcAccessExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-subscriptions-nfc-access', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsPropertiesExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "deadlines/export-subscriptions-properties/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsNfcPropertiesExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "deadlines/export-subscriptions-nfc-properties/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getDocumentsExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-documents', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getPropertyDocumentsExport = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "deadlines/export-property-documents/" + propertyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @param data List of properties to renew subscriptions
     * @since 1.0.0
     */
    DeadlinesService.prototype.renewSubscriptionsDeadline = function (data) {
        return this.apiService.apiCall("PATCH", 'deadlines/renew-subscriptions', data);
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @param data List of properties to renew subscriptions
     * @since 1.0.0
     */
    DeadlinesService.prototype.renewSubscriptionsSuppliersDeadline = function (data) {
        return this.apiService.apiCall("PATCH", 'deadlines/renew-subscriptions-suppliers', data);
    };
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getNfcAccessSubscriptionsList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'deadlines/subscriptions-nfc-access', params);
    };
    /**
     * Get an exportation file of all deadlines
     *
     * @param data List of properties to renew subscriptions
     * @since 1.0.0
     */
    DeadlinesService.prototype.renewSubscriptionsNfcAccessDeadline = function (data) {
        return this.apiService.apiCall("PATCH", 'deadlines/renew-subscriptions-nfc-access', data);
    };
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getSubscriptionsPrivacyList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'deadlines/subscriptions-privacy', params);
    };
    /**
     * Get an exportation file of all privacy deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsPrivacyExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-subscriptions-privacy', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties paying privacy subscription for the given company
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsPrivacyPropertiesExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "deadlines/export-subscriptions-privacy-properties/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Renew the privacy deadline for the given list of companies
     *
     * @param data List of companies to renew privacy subscriptions
     * @since 1.0.0
     */
    DeadlinesService.prototype.renewSubscriptionsPrivacyDeadline = function (data) {
        return this.apiService.apiCall("PATCH", 'deadlines/renew-subscriptions-privacy', data);
    };
    /**
     * Get deadlines list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DeadlinesService.prototype.getSubscriptionsPrivacySagList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'deadlines/subscriptions-privacy-sag', params);
    };
    /**
     * Get an exportation file of all privacy sag deadlines
     *
     * @since 1.0.0
     */
    DeadlinesService.prototype.getSubscriptionsPrivacySagExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'deadlines/export-subscriptions-privacy-sag', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    DeadlinesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeadlinesService_Factory() { return new DeadlinesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: DeadlinesService, providedIn: "root" });
    return DeadlinesService;
}());
export { DeadlinesService };
